import React from 'react';
import ButtonPrimary from '../../../../../Common/Button/Primary/ButtonPrimary';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Successfully } from '../../../../../../assets/images/success_blue.svg';
import styles from './PasswordRecoveryFinished.module.scss';
import StepDescription from '../../../../Features/StepDescription/StepDescription';

function PasswordRecoveryFinished() {
  const { t } = useTranslation();
  const navigation = useNavigate();
  return (
    <div className={styles.container}>
      <Successfully className={styles.icon} />
      <StepDescription>{t('recovery.password.finished.title')}</StepDescription>
      <ButtonPrimary className={styles.button} label={t('recovery.password.finished.button')} onClick={() => navigation('/auth/login')} />
    </div>
  );
}

export default PasswordRecoveryFinished;
